import { render, staticRenderFns } from "./AlternativeNameButton.vue?vue&type=template&id=c666fa4c&scoped=true"
import script from "./AlternativeNameButton.vue?vue&type=script&lang=js"
export * from "./AlternativeNameButton.vue?vue&type=script&lang=js"
import style0 from "./AlternativeNameButton.vue?vue&type=style&index=0&id=c666fa4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c666fa4c",
  null
  
)

export default component.exports